import React, { Fragment } from "react";
import { DollarSign, Tag, ShoppingBag, Sun } from "react-feather";
import CountUp from "react-countup";
import { Link, Redirect } from "react-router-dom";
import ChartistGraph from "react-chartist";
// import { chart1, chartsmall } from "../../../charts-data/default";

const primary = localStorage.getItem("primary_color") || "#4466f2";
const secondary = localStorage.getItem("secondary_color") || "#1ea6ec";

const EventCharts = (infoProps) => {
  var { totalStack, onClickEvent } = infoProps;
  if (totalStack && totalStack.length > 0) {
    totalStack = totalStack[0];
  }

  console.log({ totalStack });
  return (
    <Fragment>
      <div className="col-md-3">
        <div
          className="card"
          style={{ backgroundColor: "#40a649", color: "#ffffff" }}
        >
          <Link to="/staffMember/all">
            <div
              className="card-body"
              style={{ padding: "15px", color: "#ffffff" }}
            >
              <div className="chart-widget-dashboard">
                <div className="media">
                  <div className="media-body">
                    <h5 className="mt-0 mb-0 f-w-600">
                      {/* <DollarSign /> */}
                      <span style={{ color: "#ffffff" }}>All Members</span>
                    </h5>
                    <h2 style={{ marginTop: "10px", color: "#ffffff" }}>
                      <CountUp
                        className="counter"
                        end={totalStack.totalCount || 0}
                      />
                    </h2>
                  </div>
                  <i
                    className="icofont icofont-users-alt-5"
                    style={{
                      fontSize: "50px",
                      fontSize: "65px",
                      lineHeight: "47px",
                      color: "#ffffff",
                    }}
                  ></i>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div className="col-md-3">
        <div
          className="card"
          style={{ backgroundColor: "#0979fb", color: "#ffffff" }}
        >
          <Link to="/staffMember/subscribed">
            <div className="card-body" style={{ padding: "15px" }}>
              <div className="chart-widget-dashboard">
                <div className="media">
                  <div className="media-body">
                    <h5 className="mt-0 mb-0 f-w-600">
                      {/* <DollarSign /> */}
                      <span style={{ color: "#ffffff" }}>Subscribed </span>
                    </h5>
                    <h2 style={{ marginTop: "10px", color: "#ffffff" }}>
                      <CountUp
                        className="counter"
                        end={totalStack.totalSubscribe || 0}
                      />
                    </h2>
                  </div>
                  <i
                    className="icofont icofont-cur-rupee-plus"
                    style={{ fontSize: "50px", color: "#ffffff" }}
                  ></i>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div className="col-md-3">
        <div
          className="card"
          style={{ backgroundColor: "#39aed5", color: "#ffffff" }}
        >
          <Link to="/staffMember/unsubscribed">
            <div className="card-body" style={{ padding: "15px" }}>
              <div className="chart-widget-dashboard">
                <div className="media">
                  <div className="media-body">
                    <h5 className="mt-0 mb-0 f-w-600">
                      {/* <DollarSign /> */}
                      <span style={{ color: "#ffffff" }}>Unsubscribed </span>
                    </h5>
                    <h2 style={{ marginTop: "10px", color: "#ffffff" }}>
                      <CountUp
                        className="counter"
                        end={totalStack.totalUnsubscribe || 0}
                      />
                    </h2>
                  </div>
                  <i
                    className="icofont icofont-delete-alt"
                    style={{ fontSize: "50px", color: "#ffffff" }}
                  ></i>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div className="col-md-3">
        <div
          className="card"
          style={{ backgroundColor: "#de3d46", color: "#ffffff" }}
        >
          <Link to="/staffMember/all">
            <div className="card-body" style={{ padding: "15px" }}>
              <div className="chart-widget-dashboard">
                <div className="media">
                  <div className="media-body ">
                    <h5 className="mt-0 mb-0 f-w-600">
                      {/* <DollarSign /> */}
                      <span style={{ color: "#ffffff" }}>Collection</span>
                    </h5>
                    <h2 style={{ marginTop: "10px", color: "#ffffff" }}>
                      <CountUp className="counter" end={0} />
                    </h2>
                  </div>
                  <i
                    className="icofont icofont-cur-rupee"
                    style={{ fontSize: "50px", color: "#ffffff" }}
                  ></i>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </Fragment>
  );
};

export default EventCharts;
